import React from 'react'
import { Collection } from '../../../types/contentManagement'
import { EmailItem } from './emailsData'
import { Box, Button, Divider, Heading, Select, Stack } from '@chakra-ui/react'

interface CollectionsListProps {
  collections: Collection[]
  selectedCollection: Collection
  handleCollectionChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
  setSelectedCollection: (collection: Collection) => void
  isMobile: boolean
  emails: EmailItem[]
  selectedEmailKey: string | null
  onEmailSelect: (key: string) => void
}

interface MobileCollectionsMenuProps {
  collections: Collection[]
  selectedCollection: Collection
  handleCollectionChange: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

interface DesktopCollectionsMenuProps {
  collections: Collection[]
  activeCollectionName: string | null
  setSelectedCollection: (collection: Collection) => void
}

const MobileCollectionsMenu: React.FC<MobileCollectionsMenuProps> = ({
  collections,
  selectedCollection,
  handleCollectionChange,
}) => (
  <Select
    mb={4}
    onChange={handleCollectionChange}
    value={selectedCollection.name}
  >
    {collections.map((collection) => (
      <option key={collection.name} value={collection.name}>
        {collection.name}
      </option>
    ))}
  </Select>
)

const DesktopCollectionsMenu: React.FC<DesktopCollectionsMenuProps> = ({
  collections,
  activeCollectionName,
  setSelectedCollection,
}) => (
  <Stack spacing={2}>
    {collections.map((collection) => (
      <Button
        key={collection.name}
        variant='ghost'
        onClick={() => setSelectedCollection(collection)}
        isActive={activeCollectionName === collection.name}
      >
        {collection.name}
      </Button>
    ))}
  </Stack>
)

const CollectionsMenu: React.FC<CollectionsListProps> = ({
  collections,
  selectedCollection,
  handleCollectionChange,
  setSelectedCollection,
  isMobile,
  emails,
  selectedEmailKey,
  onEmailSelect,
}) => {
  return (
    <Box
      w={{ base: '100%', md: '250px' }}
      p={4}
      borderRight={{ md: '1px solid #e2e8f0' }}
      mb={4}
    >
      <Heading size='md' mb={4}>
        Collections
      </Heading>
      {isMobile && (
        <MobileCollectionsMenu
          collections={collections}
          selectedCollection={selectedCollection}
          handleCollectionChange={handleCollectionChange}
        />
      )}
      {!isMobile && (
        <DesktopCollectionsMenu
          collections={collections}
          activeCollectionName={selectedEmailKey !== null ? null : selectedCollection.name}
          setSelectedCollection={setSelectedCollection}
        />
      )}
      <Divider my={4} />
      <Heading size='md' mb={4}>
        Emails
      </Heading>
      <Stack spacing={2}>
        {emails.map((email) => (
          <Button
            key={email.key}
            variant='ghost'
            onClick={() => onEmailSelect(email.key)}
            isActive={selectedEmailKey === email.key}
          >
            {email.name}
          </Button>
        ))}
      </Stack>
    </Box>
  )
}

export default CollectionsMenu
